import Base from "@/controllers/base";
export default class AuditCharge extends Base {
  constructor(elem) {
    super(elem);
  }

  next(event) {
    var selector = "a.view-charges span";
    var row = this.navRow(event, 1);
    if (row) EHtml.setUrl(row.getElement().querySelector(selector).dataset.url);
  }

  prev(event) {
    var selector = "a.view-charges span";
    var row = this.navRow(event, -1);
    if (row) EHtml.setUrl(row.getElement().querySelector(selector).dataset.url);
  }

  navRow(event, direction) {
    var cid = event.target.dataset.id;
    var selector = "a.view-charges span";
    var tabulator = document.querySelector(".tabulator#audit-charges");
    tabulator.dispatchEvent(new CustomEvent("tabulator"));
    var rows = tabulator.table.getRows().sort((a, b) => {
      return a.getPosition() - b.getPosition();
    });
    var index = rows.findIndex(
      (row) => row.getElement().querySelector(selector).dataset.id == cid
    );
    return rows[index + direction];
  }
}
